import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const SITE = "VR Packaging & Hygiene";
const HOST = "https://vrpackaging.co.nz";

const truncate = (s, n = 155) => {
  if (!s) return "";
  const t = s.replace(/\s+/g, " ").trim();
  return t.length > n ? t.slice(0, n - 1).trimEnd() + "…" : t;
};

// Removes duplicate meta[name=description] tags injected by runtime shims (e.g. preview
// tooling) so only Helmet's page-specific description remains. Helmet appends last, so
// we keep the last occurrence.
const useDedupeMeta = () => {
  useEffect(() => {
    const prune = () => {
      const nodes = document.querySelectorAll('meta[name="description"]');
      if (nodes.length <= 1) return;
      // keep only the last one
      for (let i = 0; i < nodes.length - 1; i++) {
        nodes[i].parentNode && nodes[i].parentNode.removeChild(nodes[i]);
      }
    };
    prune();
    const t1 = setTimeout(prune, 300);
    const t2 = setTimeout(prune, 1500);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  });
};

export const SEO = ({ title, description, path = "", image }) => {
  useDedupeMeta();
  const fullTitle = title ? title : SITE;
  const desc = truncate(description || "Wholesale packaging, hygiene and safety supplies for New Zealand businesses. 1,700+ products, trade pricing, nationwide dispatch.");
  const url = `${HOST}${path.startsWith("/") ? path : `/${path}`}`.replace(/\/$/, "") || HOST;
  const img = image || `${HOST}/vr-logo.jpg`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
};

export const productSEO = (p) => ({
  title: `Buy ${p.name} | VR Packaging`,
  description: `Buy ${p.name} (SKU ${p.sku}) wholesale from VR Packaging & Hygiene. ${truncate(p.description || "", 100)} Request a trade quote — nationwide NZ delivery.`,
  path: `/product/${p.slug || p.sku}`,
  image: (p.images && p.images.length) ? p.images[0] : undefined,
});
